import './styles.scss'

const B2becSpinner = ({ isLoading = false, isComponentLoading = false }) => {
  return (
    <>
      {isLoading && (
        <div
          data-testid="loading-icon"
          className={isComponentLoading ? 'spinner__component-loader' : 'spinner__loader'}
        >
          <div className="spinner__loader__icon" />
        </div>
      )}
    </>
  )
}

export default B2becSpinner
